import { AppState } from '../../../root-reducer';
import { CreateParticipantState } from './definitions';

const selectCreateParticipant = (state: AppState): CreateParticipantState => state.createParticipantReducer;

export const selectCreateParticipantLoading = (state: AppState): boolean => selectCreateParticipant(state).loading;

export const selectCreateParticipantError = (state: AppState): string | null => selectCreateParticipant(state).error;
